export default function* rootSaga() {
	yield ([]);
}
